const dataBanner = [
    {
        id: 1,
        heading: 'PLATAFORMA DE E-LEARNING',
        sub_heading: 'Personalizamos plataformas para capacitar utilizando contenidos interactivos.Personalizamos plataformas para capacitar utilizando contenidos interactivos',
        img1: '/assets/cerv/home/01.png',
        img2: '/assets/cerv/home/regalo01.png',
        img3: '/assets/cerv/home/regalo01.png',
        img4: '/assets/cerv/home/regalo01.png',
        link: '/e-learning'
    },
    {
        id: 2,
        heading: 'SIMULADORES',
        sub_heading: 'Creamos simuladores en áreas seguridad / mantenimiento / operaciones que replican escenarios reales, ayudando a los usuarios a practicar y mejorar sus competencias.',
        img1: '/assets/cerv/home/02.png',
        img2: '/assets/cerv/home/regalo01.png',
        img3: '/assets/cerv/home/regalo01.png',
        img4: '/assets/cerv/home/regalo01.png',
        link: '/simulators'
    },
    {
        id: 3,
        heading: 'CAPACITACIONES',
        sub_heading: 'Impartimos entrenamientos especializados para desarrollar habilidades técnicas y promover una cultura de seguridad.',
        img1: '/assets/cerv/home/03.png',
        img2: '/assets/cerv/home/regalo01.png',
        img3: '/assets/cerv/home/regalo01.png',
        img4: '/assets/cerv/home/regalo01.png',
        link: '/training'
    },
    {
        id: 4,
        heading: 'APLICACIONES DE GESTION HSE',
        sub_heading: 'Desarrollamos soluciones móviles y digitales para gestionar procesos de seguridad.',
        img1: '/assets/cerv/home/04.png',
        img2: '/assets/cerv/home/regalo01.png',
        img3: '/assets/cerv/home/regalo01.png',
        img4: '/assets/cerv/home/regalo01.png',
        link: '/hse-management'
    }
]

export default dataBanner;